var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsFixed24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1499 9.16658C17.7665 5.69158 15.0082 2.93325 11.5332 2.54992V0.833252H9.86654V2.54992C6.39154 2.93325 3.6332 5.69158 3.24987 9.16658H1.5332V10.8333H3.24987C3.6332 14.3083 6.39154 17.0666 9.86654 17.4499V19.1666H11.5332V17.4499C15.0082 17.0666 17.7665 14.3083 18.1499 10.8333H19.8665V9.16658H18.1499ZM10.6999 6.66658C8.8582 6.66658 7.36654 8.15825 7.36654 9.99992C7.36654 11.8416 8.8582 13.3333 10.6999 13.3333C12.5415 13.3333 14.0332 11.8416 14.0332 9.99992C14.0332 8.15825 12.5415 6.66658 10.6999 6.66658ZM4.86654 9.99992C4.86654 13.2249 7.47487 15.8333 10.6999 15.8333C13.9249 15.8333 16.5332 13.2249 16.5332 9.99992C16.5332 6.77492 13.9249 4.16659 10.6999 4.16659C7.47487 4.16659 4.86654 6.77492 4.86654 9.99992Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsFixed24Px);
export default __webpack_public_path__ + "static/media/gps_fixed_24px.5bb807d5904561950075b29340ae3c11.svg";
export { ForwardRef as ReactComponent };